import {
    GET_APPOINTMENT_COUNT,
    APPOINTMENT_COUNT_ERROR,
    GET_ALL_APPOINTMENTS,
    ALL_APPOINTMENTS_ERROR,
    GET_LATEST_APPOINTMENTS,
    LATEST_APPOINTMENTS_ERROR,
} from '../actions/types';


const initialState = { appointments: [], appointment: null, loading: true, error: {} }

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ALL_APPOINTMENTS:
        case GET_LATEST_APPOINTMENTS:
            return {
                ...state,
                appointments: payload,
                loading: false
            }
        case GET_APPOINTMENT_COUNT:
            return {
                ...state,
                appointment: payload,
                loading: false
            }
        case APPOINTMENT_COUNT_ERROR:
        case ALL_APPOINTMENTS_ERROR:
        case LATEST_APPOINTMENTS_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            }
        default:
            return state;
    }

}